import { themeStyle } from '@src/theming';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  position: relative;
  height: 100%;
  width: 100%;
`;

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  // See packages=>ui=>src=>deprecated=>Modal=>theme.ts => defaultTheme.zIndex for explanation
  z-index: ${themeStyle.zIndexL1 + 1};
`;
